import queryString from 'query-string';
import http from '../httpConfig';
import { AddEditApi } from '../interfaces/property.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: any) => {
  const { page, perPage, orderBy, order, ...filters } = payload;
  const paging = buildPagingResponse({ page, perPage, orderBy, order });
  const url = `${API_ENDPOINTS.listProperties}?${queryString.stringify(paging)}`;
  return http.post(url, filters);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addProperty, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editProperty}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getProperty}/${id}`);
};

const kpis = () => {
  return http.get(API_ENDPOINTS.propertyKpis);
};

const getDocuments = (id: string) => {
    return http.get(`${API_ENDPOINTS.propertyDocs}/${id}`);
};

const deleteDocument = (payload: { ids: number[], property_id: number }) => {
    return http.delete(API_ENDPOINTS.propertyDoc, { data: payload });
};

const syncGovernmentProjects = (payload: { state_code: string }) => {
  return http.post(API_ENDPOINTS.syncGovernmentProjects, payload);
};

const deleteProperty = (id: number) => {
  return http.delete(`${API_ENDPOINTS.deleteProperty}/${id}`);
};

const PropertyService = {
  list,
  add,
  edit,
  get,
  kpis,
  getDocuments,
  deleteDocument,
  syncGovernmentProjects,
  deleteProperty,
};

export default PropertyService;
